import axios from 'axios';
import { baseConfig } from './baseClient';

export const publicClient = axios.create(baseConfig);

publicClient.interceptors.request.use(
  (config) => config,
  (error) => {
    return Promise.reject(new Error(error));
  },
);
